export default {
    computed: {
        profile() {
            return this.$store.state.profile;
        },
        query() {
            return this.$store.state.query;
        },
        userid() {
            return this.$store.state.userid;
        },
        serverUrl() {
            return 'https://communitybotbyzwizai.herokuapp.com/';
        },
    },
    methods: {
        numberFormat(val) {
            return new Intl.NumberFormat().format(parseInt(val))
        },
        async checkEmailOrPhone(value, type = "all") {
            let result = { type: null, status: false };
            // for phone number
            if (type == 'phone' || type == 'all') {
                const phonePattern = new RegExp(/^[0][3-9][0-9]{4}[0-9]{4}$/);
                const phoneStatus = phonePattern.test(value);
                if (phoneStatus) {
                    result.type = "phone";
                    result.status = true;
                    return result;
                }
            }

            // for email
            if (type == 'email' || type == 'all') {
                const emailPattern = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                const emailStatus = emailPattern.test(String(value).toLowerCase());
                if (emailStatus) {
                    result.type = "email";
                    result.status = true;
                    return result;
                }
            }

            // Doesn't match any format both phone number and email
            return result;
        },
    },
}